/**
 * A Grand total of $0 or less is never a price: it only gets saved when the
 * rep clears the Grand total field. Before this guard that saved total made
 * the commission -(cost + fees), so Payment Method showed $0 and a negative
 * Company Profit with the slider pinned at the far left, and every tap on +
 * only moved it $50 out of thousands (Jaron, Oct 12 2026, 13278747056).
 *
 * Such a total is treated as "no price picked yet": commission 0, same as a
 * new deal.
 */
export const storedGrandTotalIsEmpty = (
  payment: Readonly<{ grandTotalWDF?: unknown }> | null | undefined,
): boolean =>
  payment != null &&
  typeof payment.grandTotalWDF === 'number' &&
  !(payment.grandTotalWDF > 0)

/**
 * Grand total for a commission of 0 (cost + fees, grossed up by the dealer
 * fee), rounded UP to the next $50 so the commission it implies is never
 * negative.
 */
export const floorGrandTotal = (
  totalCostPlusFees: number,
  dealerFee: number,
): number => {
  const raw = totalCostPlusFees / (1 - dealerFee)
  return Math.ceil((raw - 1e-6) / 50) * 50
}
